import React from 'react'

import PaginationLink from './Components/PaginationLink'
import PreviousLinkElement from './Components/PreviousLinkElement'
import NextLinkElement from './Components/NextLinkElement'

export default class PaginationSection extends React.Component {
  constructor() {
    super()
    this.onClick = this.onClick.bind(this)
  }

  onClick(pageNumber) {
    return this.props.onPaginate(pageNumber)
  }

  isCurrentPage(page) {
    return page === this.props.currentPage
  }

  render() {
    if (this.props.totalPages == 0) {
      return null
    }

    return (
      <ul className="pagination">
        {!this.isCurrentPage(1)
        && (
        <li>
          <PaginationLink
            pageNumber={this.props.currentPage - 1}
            onPaginationLinkClick={this.onClick}
            linkText={<PreviousLinkElement />}
            useHistoryApi={this.props.useHistoryApi}
          />
        </li>
        )
        }
        <li>
          <span>{this.props.currentPage} of {this.props.totalPages}</span>
        </li>
        {!this.isCurrentPage(this.props.totalPages)
        && (
        <li>
          <PaginationLink
            pageNumber={this.props.currentPage + 1}
            onPaginationLinkClick={this.onClick}
            linkText={<NextLinkElement />}
            useHistoryApi={this.props.useHistoryApi}
          />
        </li>
        )
        }
      </ul>
    )
  }
}
